var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-561.000000, -1244.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "case"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.3125,1247.42857 C578.244141,1247.42857 579,1248.19643 579,1249.14286 L579,1258.28571 C579,1259.23214 578.244141,1260 577.3125,1260 L562.6875,1260 C561.755859,1260 561,1259.23214 561,1258.28571 L561,1249.14286 C561,1248.19643 561.755859,1247.42857 562.6875,1247.42857 L565.5,1247.42857 L565.5,1245.71429 C565.5,1244.76786 566.255859,1244 567.1875,1244 L572.8125,1244 C573.744141,1244 574.5,1244.76786 574.5,1245.71429 L574.5,1247.42857 L577.3125,1247.42857 Z M567.1875,1245.71429 L567.1875,1247.42857 L572.8125,1247.42857 L572.8125,1245.71429 L567.1875,1245.71429 Z M562.6875,1258.28571 L565.5,1258.28571 L565.5,1249.14286 L562.6875,1249.14286 L562.6875,1258.28571 Z M567.1875,1258.28571 L572.8125,1258.28571 L572.8125,1249.14286 L567.1875,1249.14286 L567.1875,1258.28571 Z M577.3125,1258.28571 L577.3125,1249.14286 L574.5,1249.14286 L574.5,1258.28571 L577.3125,1258.28571 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.74bdf925.svg";
export { ForwardRef as ReactComponent };